export var ApplicationGroupEvent;
(function (ApplicationGroupEvent) {
    ApplicationGroupEvent["PrimaryApplicationSet"] = "PrimaryApplicationSet";
    ApplicationGroupEvent["DescriptorsDataChanged"] = "DescriptorsDataChanged";
    ApplicationGroupEvent["DeviceWillRestart"] = "DeviceWillRestart";
})(ApplicationGroupEvent || (ApplicationGroupEvent = {}));
